import type { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'quiet';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: ButtonVariant;
  /** Show the present-continuous label and 45% opacity while an action runs (brand Button guideline). */
  readonly busy?: boolean;
  readonly children: ReactNode;
}

/** Brand Button: primary (brand fill), secondary (outlined), quiet (text only). One primary per view. */
export function Button({
  variant = 'secondary',
  busy = false,
  children,
  className,
  ...rest
}: ButtonProps): ReactElement {
  const classes = ['btn', `btn--${variant}`, className].filter(Boolean).join(' ');
  return (
    <button
      type="button"
      className={classes}
      aria-busy={busy || undefined}
      disabled={rest.disabled || busy}
      {...rest}
    >
      {children}
    </button>
  );
}
